import Select from 'react-select';
import { IndicatorSeparator, DropdownIndicator, LoadingIndicator, commonReactSelectStyles } from './BaseSelect.styles';
import { generateReactSelectStyles } from '../../../util/util';

/**
 * Select component that handles overwriting styles and components with
 * the current platform styling.
 * @param {boolean} defaultSelect Flag indicating if a Select control should be render comign as it is from the library.
 * @param {*} rest Props inherited from react-select library
 * @returns Returns a react-select component with the props indicated and the proper styling.
 *
 * This components comes as a result of an upgrade of the library coming from v1 to v5,
 * that changes internal structure of react-select and class names as well.
 * For more information:
 * https://react-select.com
 * https://react-select.com/upgrade
 *
 * This control caontains modifications on comnponents and styles when defaultSelect set to false,
 * so it adjusts to have a fixed height and styles to maintain previous functionalities.
 */
const BaseSelect = ({ defaultSelect = true, ...rest }) => {
  let controlToReturn = <Select {...rest} />;

  if (!defaultSelect) {
    controlToReturn = (
      <Select
        {...rest}
        components={{
          IndicatorSeparator,
          DropdownIndicator,
          LoadingIndicator,
          ...(rest.components ?? {}),
        }}
        styles={generateReactSelectStyles(commonReactSelectStyles, rest.styles ?? {})}
      />
    );
  }

  return controlToReturn;
};

export default BaseSelect;
